import { render } from "./ModalMsg.vue?vue&type=template&id=c9e143be&scoped=true&ts=true"
import script from "./ModalMsg.vue?vue&type=script&lang=ts"
export * from "./ModalMsg.vue?vue&type=script&lang=ts"

import "./ModalMsg.vue?vue&type=style&index=0&id=c9e143be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Hirofumi\\repository\\suite_totalling\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9e143be"]])

export default __exports__